import { useEffect, useRef } from 'react';

const isIOSDevice = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isTouchMac = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return /iPad|iPhone|iPod/.test(userAgent) || isTouchMac;
};

export const useScrollLock = (isLocked) => {
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    const body = document.body;
    const html = document.documentElement;

    if (!body || !html) {
      return undefined;
    }

    if (!isLocked) {
      body.classList.remove('scroll-locked');
      html.style.overflow = '';
      return undefined;
    }

    const iosDevice = isIOSDevice();
    scrollPositionRef.current = window.scrollY;

    body.classList.add('scroll-locked');
    html.style.overflow = 'hidden';

    if (iosDevice) {
      body.style.overflow = 'hidden';
      body.style.touchAction = 'none';
      body.style.webkitOverflowScrolling = 'auto';
    } else {
      body.style.position = 'fixed';
      body.style.top = `-${scrollPositionRef.current}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }

    return () => {
      body.classList.remove('scroll-locked');
      html.style.overflow = '';
      body.style.overflow = '';
      body.style.touchAction = '';
      body.style.webkitOverflowScrolling = '';
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      window.scrollTo(0, scrollPositionRef.current);
    };
  }, [isLocked]);
};
